<template>
  <van-popup
    v-model:show="show"
    round
    closeable
    :style="{
      width: '80%',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      background: '#f0f3f5',
    }"
  >
    <div class="statement-bg">
      <div v-html="statement"></div>
    </div>
    <van-button
      class="button"
      round
      block
      type="default"
      icon-position="center"
      color="linear-gradient(to right,#f48260, #e53531)"
      url="http://www.zsnews.cn/app/mobile.html"
      >下载中山+新闻客户端</van-button
    >
  </van-popup>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { Popup, Button } from "vant";
import "@/plugins/bridge.js";
export default {
  name: "Statement",
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
  },
  setup() {
    const store = useStore();
    const showBtn = ref(false);
    const userAgentString = navigator.userAgent.toLowerCase();
    if (userAgentString.indexOf("zsrbapp") < 0) {
      showBtn.value = true;
    }
    return {
      statement: computed(() => store.state.statement),
      showBtn,
    };
  },
  created() {
    const { aplus_queue } = window;
    aplus_queue.push({
      action: "aplus.sendPV",
      arguments: [
        {
          is_auto: false,
        },
        {
          param: "statement",
        },
      ],
    });
  },
  computed: {
    show: {
      get() {
        return this.$store.state.showStatement;
      },
      set(value) {
        this.$store.commit("updateShowStatement", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.statement-bg {
  width: 85%;
  min-height: 200px;
  text-align: left;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
